import { render, staticRenderFns } from "./ReturnPartsListSideMenu.vue?vue&type=template&id=3720b92b&scoped=true"
import script from "./ReturnPartsListSideMenu.vue?vue&type=script&lang=js"
export * from "./ReturnPartsListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./ReturnPartsListSideMenu.vue?vue&type=style&index=0&id=3720b92b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720b92b",
  null
  
)

export default component.exports